import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { QRCodeComponent } from 'angularx-qrcode';
import { CommonModule } from '@angular/common';
import { PipesModule } from '../pipes/pipes.module';
import { DirectiveModule } from '../directives/directive.module';
import { TopHeaderComponent } from '../../components/top-header/top-header.component';
import { TopBarComponent } from '../../components/top-bar/top-bar.component';
import { AuthenticationComponent } from '../../components/authentication/authentication.component';
import { CheckboxComponent } from '../../components/checkbox/checkbox.component';
import { HistoryEventsComponent } from '../../components/history-events/history-events.component';
import { ProgressBarComponent } from '../../components/progress-bar/progress-bar/progress-bar.component';
import { SlideComponent } from '../../components/slide/slide.component';
import { AddressCardComponent } from '../../components/address-card/address-card.component';
import { ButtonFidelityComponent } from '../../components/button-fidelity/button-fidelity.component';
import { CardLoadingComponent } from '../../components/CardLoading/card-loading/card-loading.component';
import { CheckboxRadiusComponent } from '../../components/checkbox-radius/checkbox-radius.component';
import { CopyButtonComponent } from '../../components/copy-button/copy-button.component';
import { CounterTimingComponent } from '../../components/counter-timing/counter-timing.component';
import { CupomComponent } from '../../components/cupom/cupom.component';
import { FormChangeComponent } from '../../components/form-change/form-change.component';
import { InfoCompanyComponent } from '../../components/info-company/info-company.component';
import { InputCopyPixComponent } from '../../components/input-copy-pix/input-copy-pix.component';
import { MethodCardComponent } from '../../components/method-card/method-card.component';
import { MinValueComponent } from '../../components/min-value/min-value.component';
import { ModalFidelityComponent } from '../../components/modal-fidelity/modal-fidelity.component';
import { ModalPromotionComponent } from '../../components/modal-promotion/modal-promotion.component';
import { ObservationCardComponent } from '../../components/observation-card/observation-card.component';
import { OrderDocumentComponent } from '../../components/order-document/order-document.component';
import { OrderFooterComponent } from '../../components/order-footer/order-footer.component';
import { PaymentFormCardComponent } from '../../components/payment-form-card/payment-form-card.component';
import { ReceiptCardComponent } from '../../components/receipt-card/receipt-card.component';
import { TimeAwaitComponent } from '../../components/time-await/time-await.component';
import { FormatationCurrencyDirective } from '../../directives/formatationCurrency.directive';
import { SplashComponent } from '../../components/splash/splash.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MapaComponent } from '../../components/mapa/mapa.component';
import { CounterCancelledComponent } from '../../components/counter-cancelled/counter-cancelled.component';
import { ReceiptMethodComponent } from '../../components/receipt-method/receipt-method.component';
import { CounterCancelledConsumptionComponent } from '../../components/counter-cancelled-consumption/counter-cancelled-consumption.component';
import { ProductMenuComponent } from '../../components/product-menu/product-menu.component';
import { CashbackComponent } from '../../components/cashback/cashback.component';
import { RulesCashbackComponent } from '../../components/rules-cashback/rules-cashback.component';
import { BannersComponent } from '../../components/banners/banners.component';
import { NavTopComponent } from '../../components/nav-top/nav-top.component';

const components = [
  TopHeaderComponent,
  TopBarComponent,
  HistoryEventsComponent,
  ProgressBarComponent,
  SlideComponent,
  AuthenticationComponent,
  CheckboxComponent,
  FormChangeComponent,
  ReceiptCardComponent,
  CheckboxRadiusComponent,
  MethodCardComponent,
  PaymentFormCardComponent,
  AddressCardComponent,
  CardLoadingComponent,
  CopyButtonComponent,
  InputCopyPixComponent,
  CounterTimingComponent,
  CupomComponent,
  ObservationCardComponent,
  TimeAwaitComponent,
  ModalPromotionComponent,
  FormatationCurrencyDirective,
  ButtonFidelityComponent,
  ModalFidelityComponent,
  InfoCompanyComponent,
  OrderFooterComponent,
  OrderDocumentComponent,
  MinValueComponent,
  SplashComponent,
  MapaComponent,
  CounterCancelledComponent,
  ReceiptMethodComponent,
  CounterCancelledConsumptionComponent,
  ProductMenuComponent,
  CashbackComponent,
  RulesCashbackComponent,
  BannersComponent,
  NavTopComponent
]

const modules = [
  CommonModule,
  PipesModule,
  DirectiveModule,
  FormsModule,
  ReactiveFormsModule,
  FormsModule,
  QRCodeComponent
]

@NgModule({
  declarations: components,
  imports: modules,
  exports: [...modules, ...components],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }
